import script from "./PaperLibraryPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperLibraryPanel.vue?vue&type=script&setup=true&lang=js"

import "./PaperLibraryPanel.vue?vue&type=style&index=0&id=6f80aa7c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f80aa7c"]])

export default __exports__